import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

import {
  widgetsMock,
  chartFiltersMock,
  donutChartMock,
  barsChartMock,
  courseDrawerMock,
} from '../myTeam.mock';

const getWidgets = rest.get(
  `${API_REST_URL}/my-team-report/widgets/:clientId/:bossId`,
  (req, res, ctx) => {
    return res(
      // ctx.delay(2000),
      // ctx.status(403),
      ctx.json({ data: widgetsMock }),
    );
  },
);

const getChartFilters = rest.get(
  `${API_REST_URL}/my-team-report/chart-filters/:clientId/:bossId`,
  (req, res, ctx) => {
    return res(
      // ctx.delay(2000),
      // ctx.status(403),
      ctx.json({ data: chartFiltersMock }),
    );
  },
);

const getChart = rest.post(
  `${API_REST_URL}/my-team-report/chart/:clientId/:bossId`,
  (req, res, ctx) => {
    const chartType = (req.body as any)?.chartType;

    return res(
      // ctx.delay(2000),
      // ctx.status(403),
      ctx.json({
        data: chartType === 'DONUT' ? donutChartMock : barsChartMock,
      }),
    );
  },
);

const exportKardex = rest.post(
  `${API_REST_URL}/my-team-kardex/export/:clientId/:bossId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      // ctx.status(400),
      ctx.json({ data: {} }),
    );
  },
);

const sendReminder = rest.post(
  `${API_REST_URL}/my-team-kardex/send-reminder/:clientId/:userId`,
  (req, res, ctx) => {
    return res(ctx.delay(2000), ctx.status(400), ctx.json({ data: {} }));
  },
);

const getKardexDrawer = rest.get(
  `${API_REST_URL}/my-team-kardex/drawer/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(4000),
      // ctx.status(400),
      ctx.json({ data: courseDrawerMock }),
    );
  },
);
export const myTeamReportHandlers = [
  /* getWidgets, getChartFilters, getChart, */ exportKardex /*sendReminder,  getKardexDrawer */,
];
